import type { BookingFilter } from '../models';

export const getBaseFilter = (filter: BookingFilter) => {
    const { timeSlots, classType, dates } = filter;

    return { timeSlots, classType, dates };
};
